const baseRoute = import.meta.env.VITE_AUTH_URL;

export const workspaceRoutes = {
  switchAccount: `${baseRoute}/switchAccount`,
  logout: `${baseRoute}/logout`,
} as const;
